import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['radio', 'dialog']

  static values = {
    beforeConfirm: String,
  }

  _pendingValue = null

  askConfirmation(e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    this._pendingValue = e.target.value
    this.dialogTarget.showModal()
  }

  confirm () {
    const checkedRadio = this.radioTargets.find(input => input.checked)
    checkedRadio.dispatchEvent(new CustomEvent('confirmed', {bubbles: true}))
    this.close()
  }

  cancel (e) {
    this._pendingValue = null
    // Find the radio button with the previous value and check it
    const targetRadio = this.radioTargets.find(input => input.value === this.beforeConfirmValue)
    targetRadio.checked = true

    this.close()
  }

  close () {
    this.dialogTarget.close()
  }
}
